
import {
  FieldType,
  FieldUpdate,
  ProductField,
} from '@/modules/product/models/product.interface';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'DynamicProductForm',
  emits: ['text-change', 'font-change', 'img-change'],
  props: {
    fields: {
      type: Array as PropType<Array<ProductField[]>>,
      required: true,
    },
  },
  computed: {
    initialFont() {
      return (field: ProductField) => {
        const font = field.fontList?.find((f) => f.value === field.currentFont);
        return font?.id;
      };
    },
    fieldType() {
      return FieldType;
    },
  },
  methods: {
    inputEmitter(text: string, inputId: number): void {
      const params: FieldUpdate = {
        fieldId: inputId,
        value: text,
      };
      this.$emit('text-change', params);
    },
    fontEmitter(option: number, inputId: number): void {
      const params: FieldUpdate = {
        fieldId: inputId,
        value: +option,
      };
      this.$emit('font-change', params);
    },
    imgEmitter(option: string, inputId: number): void {
      const params: FieldUpdate = {
        fieldId: inputId,
        value: +option.split(',')[0],
      };
      this.$emit('img-change', params);
    },
  },
});
